import { render, staticRenderFns } from "./IconTextBtn.vue?vue&type=template&id=7580ae94&scoped=true&"
import script from "./IconTextBtn.vue?vue&type=script&lang=js&"
export * from "./IconTextBtn.vue?vue&type=script&lang=js&"
import style0 from "./IconTextBtn.vue?vue&type=style&index=0&id=7580ae94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580ae94",
  null
  
)

export default component.exports